import classNames from "classnames";
import Link from "next/link";
import { FC } from "react";
import { MdChevronRight } from "react-icons/md";
import IconWithTooltip from '../IconWithTooltip';
import Image from 'next/image';
import { createImageSizes } from '../../utils/image';
import FavoriteToggle from '../FavoriteToggle';

type ArticleTagProps = {
  imageSrc: string;
  roundImage?: boolean;
  label: string;
  href: string;
  tooltipText?: string;
  darkBackground?: boolean;
  id: number;
  type: string;
};

const ArticleTag: FC<ArticleTagProps> = (props) => {
  return (
    <Link href={props.href} passHref>
      <a
        className={classNames(
          "flex",
          "items-center",
          "gap-3",
          "p-4",
          "cursor-pointer",
          "font-semibold",
          "select-none",
          {
            "bg-black-lightest": props.darkBackground,
            "hover:bg-black-lightest-hover": props.darkBackground,
            "hover:bg-black-lightest": !props.darkBackground,
          }
        )}
      >
        <FavoriteToggle
          type={props.type}
          favorite={{
            id: props.id,
            image: props.imageSrc,
            name: props.label,
          }}
        />

        <div className='relative h-[30px] w-[30px]'>
          <Image
            layout='fill'
            sizes={createImageSizes({
              mobile: '5vw',
              tablet: '5vw',
              desktop: '5vw'
            })}
            className={classNames("object-cover", {
              "rounded-full": props.roundImage,
            })}
            src={props.imageSrc}
            alt={props.label}
          />
        </div>
        <p>{props.label}</p>
        {props.tooltipText ? <IconWithTooltip
                          minWidth={150}
                          text={props.tooltipText}
                          icon={
                            <div
                              className={classNames(
                                "ml-2",
                                "flex",
                                "justify-center",
                                "items-center",
                                "rounded-full",
                                "bg-black",
                                "text-white",
                                "text-xs",
                                "h-[20px]",
                                "w-[20px]"
                              )}
                            >
                              L
                            </div>
                          }
                        /> : null}
        <MdChevronRight className={classNames("ml-auto")} size={22} />
      </a>
    </Link>
  );

  return <p>This is article tag</p>;
};

export default ArticleTag;
